import {getRestRoute, getSetting} from "@ppcp/utils";
import apiFetch from "@wordpress/api-fetch";
import Actions from '@ppcp/actions';

class Order {

    constructor(props) {
        this.data = props;
        this.actions = new Actions();
    }

    /**
     *
     * @param payment_method
     * @param data
     * @returns {Promise<unknown>}
     */
    async createOrder(payment_method, data = {}) {
        return apiFetch({
            method: 'POST',
            url: getRestRoute('order/pay'),
            data: {
                payment_method,
                ...data,
                ...this.data
            }
        }).then(response => response);
    }

    needsShipping() {
        return this.actions.applyFilters('order_needs_shipping', false, this);
    }

    getCurrency() {
        return this.data.currency;
    }

    getTotal() {
        return this.data.total || 0.00;
    }

    getTotalCents() {
        return parseInt(this.data.totalCents || 0);
    }

    getLineItems() {
        return this.data.lineItems || [];
    }
}

export default new Order(getSetting('order'));